module.exports = __webpack_public_path__ + "static/media/bonus-post-banner.56a499ad.svg";